import {
  LIST_COURSE_OFFERED_FAILED,
  LIST_COURSE_OFFERED_REQ,
  LIST_COURSE_OFFERED_SUCCESS,
} from "../Constants/courseOffered";

export const COURSE_OFFERED_LIST_REDUCER = (state = {}, { type, payload }) => {
  switch (type) {
    case LIST_COURSE_OFFERED_REQ: {
      return { Course_Offered_List_Loading: true };
    }

    case LIST_COURSE_OFFERED_SUCCESS: {
      return {
        Course_Offered_List_Loading: false,
        Course_Offered_List: payload,
      };
    }

    case LIST_COURSE_OFFERED_FAILED: {
      return {
        Course_Offered_List_Loading: false,
        Course_Offered_List_Error: payload,
      };
    }

    default:
      return state;
  }
};
